export enum SiteTheme {
  SILVER = "SILVER",
  GOLD = "GOLD",
  BRONZE = "BRONZE",
  CLASSIC = "CLASSIC",
  NEON = "NEON",
  CAKE = "CAKE",
}

export enum ProjectIconName {
  VINYL = "vinyl",
  SPACE = "space",
  GRAPH = "graph",
}

export enum SliderDirection {
  LEFT = "LEFT",
  RIGHT = "RIGHT",
}

export const SITE_THEME_KEY = "jacob-site-theme";
